import { Box } from "@mui/material"
import { type FC, useState } from "react"

import { CustomerProductCommentsSection } from "./Comments/CustomerProductCommentsSection"
import { CustomerQualityPreferencesPanel } from "./CustomerQuality/CustomerQualityPreferencesPanel"
import { CustomerProductFilesSection } from "./UploadedFiles/CustomerProductFilesSection"

import { InformationMissingAlert } from "@/components/common/Alerts/InformationMissingAlert"
import { AerosSelect } from "@/components/UiKit"
import type { PreferenceAssociationItem } from "@/screens/CustomerProducts/hooks/useProductPreferenceAssociationList"

interface CustomerProductLocationSectionProps {
  associations: PreferenceAssociationItem[]
  companyId: string
  productId: number
}

export const CustomerProductLocationSection: FC<CustomerProductLocationSectionProps> = ({
  associations,
  companyId,
  productId,
}) => {
  const [selectedLocationId, setSelectedLocationId] = useState("")

  const locationOptions = associations
    .filter((association) => association.companyProductAssociationLocationId)
    .map((association) => ({
      value: association.companyProductAssociationLocationId!,
      label: association.shipToLocation?.name ?? association.companyProductAssociationLocationId!,
    }))

  const selectedAssociation =
    associations.find((association) => association.companyProductAssociationLocationId === selectedLocationId) ?? null

  return (
    <Box className='flex flex-col gap-y-4'>
      <AerosSelect
        className='w-80'
        label='Location'
        placeholder='Select a location'
        value={selectedLocationId}
        options={locationOptions}
        onChange={(value) => setSelectedLocationId(value ?? "")}
        data-testid='customer-product-location.location-select'
      />

      {!selectedAssociation ? (
        <InformationMissingAlert title='Please select a location from the dropdown above to view preferences' />
      ) : (
        <Box className='flex flex-col gap-4'>
          <CustomerQualityPreferencesPanel
            association={selectedAssociation}
            companyId={companyId}
            productId={productId}
          />
          <CustomerProductFilesSection
            companyProductAssociationLocationId={selectedAssociation.companyProductAssociationLocationId!}
          />
          <CustomerProductCommentsSection
            companyProductAssociationLocationId={selectedAssociation.companyProductAssociationLocationId!}
          />
        </Box>
      )}
    </Box>
  )
}
